module.exports = __webpack_public_path__ + "img/la_3dmodel.f62e5053.png";